import React, { useState } from "react";
import Link from "next/link";
import { SecondaryNavigationDropdownItem, SecondaryNavigationItemProps } from "@/types/layout";
import { SecondaryNavItem } from "@/components/layout/Sidebar/SecondaryNavItem";

export const SecondaryNavItemDropdown: React.FC<SecondaryNavigationItemProps> = ({ navigationItem }) => {
  const [openedSubNav, setOpenedSubNav] = useState<SecondaryNavigationDropdownItem[] | undefined>(undefined);

  function toggleOpen(dropdownMenu?: SecondaryNavigationDropdownItem[]) {
    if (!dropdownMenu) {
      return setOpenedSubNav(undefined);
    }
    return setOpenedSubNav(dropdownMenu);
  }

  return (
    <>
      <div onMouseEnter={() => toggleOpen(navigationItem.dropdownMenu)} onMouseLeave={() => toggleOpen(undefined)}>
        <SecondaryNavItem navigationItem={navigationItem} openedSubNav={openedSubNav} />
      </div>
      {openedSubNav && (
        <ul className="w-full text-md lg:absolute lg:-bottom-20 lg:-right-68 lg:w-68 lg:rounded-sm lg:bg-black lg:text-white">
          {openedSubNav?.map((item, key) => (
            <li
              key={`secondary-nav-item-${key}`}
              className="border-gray-dark border-b last:border-0 lg:border-b lg:border-white-25 lg:last:border-0"
            >
              <Link
                href={item.url}
                className="flex items-center py-4 pl-12 transition-colors ease-in-out hover:bg-white-25"
              >
                {item.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};
